export default __webpack_public_path__ + "static/media/griswoldHome.e72ee315.webp";